import {useMap} from 'react-map-gl/maplibre';

export const withHooksHOC = (Component: any) => {
  return (props: any) => {
    const {myMapA} = useMap();

    return <Component map={myMapA} {...props} />;
  };
};